import React, {CSSProperties} from "react";
import {ScrapingUtils} from "../../../utils/scraping.utils";

interface IProps {
    prop: string,
    value: number
    style: CSSProperties
}

const MetricValue: React.FC<IProps> = ({prop, style, value}) => {
    return <span style={{...style}}> {ScrapingUtils.addSignsToMetricValue(prop, value)}</span>
}


export default MetricValue;